import { Link } from 'react-router-dom';
import { leagueMeta, leagueOrder, getMatchesByLeague } from '@/lib/site';

export default function LeagueEntries() {
  return (
    <section aria-labelledby="league-entries" className="w-full">
      <div className="flex items-end justify-between gap-4 mb-4">
        <div>
          <p className="font-heading text-[11px] tracking-[0.28em] text-accent-600 mb-1">LEAGUES</p>
          <h2 id="league-entries" className="font-heading text-xl md:text-2xl text-foreground-950">
            联赛快捷入口
          </h2>
        </div>
        <span className="hidden sm:block text-xs text-foreground-500">选择联赛，查看完整赛程与直播状态</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
        {leagueOrder.map((key, i) => {
          const list = getMatchesByLeague(key);
          const liveCount = list.filter((item) => item.status === 'live').length;
          const upcomingCount = list.filter((item) => item.status === 'upcoming').length;
          return (
            <Link
              key={key}
              to={`/category/${key}`}
              className="group relative overflow-hidden rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors p-5 flex flex-col justify-between min-h-[168px] cursor-pointer"
            >
              <span className="absolute right-4 top-4 font-heading text-5xl leading-none text-background-200 group-hover:text-accent-100 transition-colors">
                0{i + 1}
              </span>
              <div className="relative">
                <span className="w-10 h-10 rounded-md bg-primary-50 text-primary-700 flex items-center justify-center text-xl mb-3">
                  <i className={leagueMeta[key].icon} />
                </span>
                <h3 className="font-heading text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {leagueMeta[key].name} 赛事直播
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 line-clamp-2">
                  {leagueMeta[key].intro}
                </p>
              </div>
              <div className="relative mt-4 flex items-center gap-3 text-[11px] text-foreground-600">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-broadcast-line text-accent-600" />
                  {liveCount} 场直播中
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-calendar-check-line text-secondary-500" />
                  {upcomingCount} 场待开赛
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}